import { Card, Collapse, Space } from "antd";
import styles from "assets/scss/jobAndClientBillingRules.module.scss";
import LayoutCss from "layout/layout.module.scss";
import { epochTimeToDashUSFormat } from "utilities/dateUtility";
import EmptyPlaceholder from "common/components/emptyPlaceholder/emptyPlaceholder.jsx";
import { CommissionPlanDetails } from "./commissionPlanDetails/commissionPlanDetails";

const { Panel } = Collapse;

export default function HistoryCommissionPlans({ plansDetails }) {
  return (
    <>
      {plansDetails.histroyRules.length === 0 ? (
        <Card
          title="History Rules"
          bordered={false}
          className={LayoutCss.appListingCard}
          style={{ marginTop: "20px" }}
        >
          <EmptyPlaceholder />
        </Card>
      ) : (
        <Card
          title="History Rules"
          bordered={false}
          className={LayoutCss.appListingCard}
          style={{ marginTop: "20px" }}
        >
          {plansDetails.histroyRules.map((item, index) => (
            <Collapse
              key={index}
              defaultActiveKey={["0"]}
              expandIconPosition="end"
              bordered={false}
            >
              <Panel
                header={epochTimeToDashUSFormat(
                  item.defaultPlan.startDate,
                  false,
                )}
                key="1"
              >
                <Card className={styles.clientBillingRulesCard}>
                  <Space
                    direction="vertical"
                    size="middle"
                    style={{ width: "100%" }}
                  >
                    <CommissionPlanDetails plan={item.defaultPlan.plan} />
                    {item.clinetException.map((item, index) => {
                      return (
                        <CommissionPlanDetails
                          key={index}
                          plan={item.plan}
                          clientName={item.plan.client.name}
                        />
                      );
                    })}
                  </Space>
                </Card>
              </Panel>
            </Collapse>
          ))}
        </Card>
      )}
    </>
  );
}
